import { api } from 'utils/hooks/useApi';
import { ISend } from './_types';

export const send = (data: ISend): Promise<boolean> => api().post(`/portal-api/mdex/send`, data);
